import React from "react";
import { Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Text from "../utilities/Text";
import Currency from "./Currency";

export default function Balance(props) {
  let totalBalance = 0;
  // let totalGrants = 0;
  if (!props.userData) {
    return null;
  }

  if (props?.userData.user?.deposits.length < 1) {
    return null;
  }

  totalBalance = props?.userData.user.total_balance;

  return (
    <Box>
      <Typography style={{}} variant="h4">
        {" "}
        <Text objectName="balance" page="mainpage" />
      </Typography>
      <Typography style={{ direction: "ltr" }} variant="h1">
        <Currency /> {Math.round(totalBalance).toLocaleString()}{" "}
      </Typography>
    </Box>
  );
}
